import * as RadixTooltip from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';
import { cn } from '@shared/lib/cn';

export const TooltipProvider = RadixTooltip.Provider;

export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

/**
 * Hover and focus tooltip (design system §4.19): inverse surface, max 240 px, 300 ms open delay.
 * Never the only place information lives — callers keep visible text or aria labels.
 */
export function Tooltip({ content, children, side = 'top', className }: TooltipProps) {
  return (
    <RadixTooltip.Root delayDuration={300}>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          side={side}
          sideOffset={6}
          collisionPadding={8}
          className={cn(
            'z-dropdown max-w-[240px] rounded-sm bg-surface-inverse px-2 py-1 text-sm text-on-inverse shadow-2',
            className,
          )}
        >
          {content}
          <RadixTooltip.Arrow className="fill-surface-inverse" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}
